import React from 'react'
import { useRouteMatch } from 'react-router-dom'
import { TaskLayout } from './layouts'
import { CustomRoute } from '../../components'

export default function TaskRoutes() {
  const { path } = useRouteMatch()
  return <CustomRoute path={path} component={TaskLayout} />
}
